import { createRoot } from "react-dom/client";
import "./index.css";
import "./app/i18n";
import App from "./App.tsx";

if (import.meta.env.DEV && "serviceWorker" in navigator && window.location.href.includes("ngrok")) {
  const isSafari = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
  if (!isSafari) navigator.serviceWorker.register("/sw-ngrok.js");
}

createRoot(document.getElementById("root")!).render(<App />);
